import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/sidebars/profile.svg'
import _imports_1 from '@/assets/icons/sidebars/lock-password.svg'
import _imports_2 from '@/assets/icons/sidebars/sign-out.svg'
import _imports_3 from '@/assets/icons/sidebars/down.svg'


const _hoisted_1 = { class: "c-navbar" }
const _hoisted_2 = {
  class: "left",
  style: {"display":"inline-grid"}
}
const _hoisted_3 = {
  class: "default-title",
  style: {"font-size":"14px","color":"var(--black-light)"}
}
const _hoisted_4 = { class: "default-title" }
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "mr15" }
const _hoisted_7 = { class: "localize" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "profile" }
const _hoisted_11 = { class: "profile-image" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_17 = { class: "name mr8" }
const _hoisted_18 = { class: "desc" }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_c_modal = _resolveComponent("c-modal")
  const _directive_outside = _resolveDirective("outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("componentPage")) + " " + _toDisplayString(_ctx.getPageBreadcrumb(_ctx.$i18n.locale,
      _ctx.$store?.state?.menus, _ctx.$route) ? ` / ${_ctx.getPageBreadcrumb(_ctx.$i18n.locale,
      _ctx.$store?.state?.menus, _ctx.$route)}` : ``), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.getPageTitle(_ctx.$store?.state?.pageTitle))), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("componentVersion")) + " : " + _toDisplayString(_ctx.version), 1),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.$helper?.i18nLocale?.value === 'en')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$changeLocalize('km')), ["stop"])),
              src: require('@/assets/icons/flags/en.svg'),
              alt: ""
            }, null, 8, _hoisted_8))
          : _createCommentVNode("", true),
        (_ctx.$helper?.i18nLocale?.value === 'km')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$changeLocalize('en')), ["stop"])),
              src: require('@/assets/icons/flags/km.svg'),
              alt: ""
            }, null, 8, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            src: _ctx.$store?.state?.profile?.imageKey ? _ctx.$helper?.getFullImage(_ctx.$store?.state?.profile?.imageKey) : require('@/assets/images/user-default.png'),
            alt: ""
          }, null, 8, _hoisted_12)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.isDropdown=!_ctx.isDropdown)),
          class: "profile-title"
        }, [
          (_ctx.isDropdown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: `/setting/user-account/detail/${_ctx.$store?.state?.profile?.id}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t('componentMyAccount')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: `/setting/user-account/update/${_ctx.$store?.state?.profile?.id}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t('componentChangePassword')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.isLogout=true))
                  }, [
                    _hoisted_16,
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('componentSignOut')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$store?.state?.profile?.fullName &&
            _ctx.$store?.state?.profile?.fullName), 1),
            _createElementVNode("img", {
              class: _normalizeClass({'down-svg':_ctx.isDropdown}),
              src: _imports_3
            }, null, 2)
          ]),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$store?.state?.profile?.roles &&
          _ctx.$store?.state?.profile?.roles[0]?.title), 1)
        ])), [
          [_directive_outside, _ctx.onClose]
        ])
      ])
    ]),
    _createVNode(_component_c_modal, {
      onOnClose: _ctx.cancelLogout,
      onOnConfirm: _ctx.onLogout,
      labelText: "componentSignOut",
      active: _ctx.isLogout
    }, null, 8, ["onOnClose", "onOnConfirm", "active"])
  ]))
}